import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./RegisterationFooter.css";
import kamaLogo from "../Images/logo.png";
import ifxexpo from "../Images/AfLogo.svg";

function RegisterationFooter() {
    return (
        <div className="reg-footer mt-5">
            
                <Row className="reg-footer-content">
                    <Col xs={6} md={6} sm={6} lg={6} className="footer-item d-flex align-items-center justify-content-start mb-3 mb-md-0">
                        <img src={kamaLogo} alt="Kama Capital Logo" className="reg-footer-logo" />
                    <a href="https://kama-capital.com/" target="_blank" rel="noopener noreferrer">
                        www.kama-capital.com
                        </a>
                    </Col>
                    <Col xs={6} md={6} sm={6} lg={6} className="footer-item d-flex align-items-center justify-content-end mb-3 mb-md-0">
                        <img src={ifxexpo} alt="affiliateworldconferences" className="reg-footer-logo" />
                    <a href="https://www.google.com/aclk?sa=l&ai=DChcSEwj-3Zb-2d6LAxWvqWYCHSn9Lx0YABAAGgJzbQ&co=1&gclid=Cj0KCQiA8fW9BhC8ARIsACwHqYpuFyisgUO0N1OLx1C4Vn3aliobX3YClr53OqIFSwK4q65YxLyrtk0aAgdkEALw_wcB&sig=AOD64_2o1XpoCcQPfYynUbwwJG7VEcRTOQ&q&adurl&ved=2ahUKEwiHhpD-2d6LAxUwT2wGHX6GPekQ0Qx6BAgJEAE" target="_blank" rel="noopener noreferrer">
                    www.affiliateworldconferences.com
                        </a>
                    </Col>
                </Row>
            
        </div>
    );
}

export default RegisterationFooter;
